import Layout from "@/components/RenderbusLayout";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Profile from "@/pages/profile";
import { ChildCustomer } from "@/pages/child-customer";
import { ProjectManage } from "@/pages/project-management";
import Coupon from "@/pages/coupon";
import Invoice from "@/pages/invoice";
import InvoiceHistory from "@/pages/invoice/components/invoice-history";
import Notification from "@/pages/notification";
import useGlobalAuth from "@/hooks/useGlobalAuth";
import { useGlobalStore } from "@/store/GlobalStore";
import { ExportList } from "@/pages/export-list";
import { OperateRecord } from "@/pages/operate-record";
import { Consumption } from "@/pages/consumption";
import { PreviousConsumption } from "@/pages/previous-consumption";
import { Payment } from "@/pages/payment";
import { AuthorizationManagement } from "@/pages/authorization-management";
import { Developer } from "@/pages/developer";
import { InviteRewards } from "@/pages/invite-rewards";
import ClientTopUp from "./pages/client-top-up";
import { useResponseInterceptor } from "./hooks/use-response-interceptor";
import { PictureTopUp } from "@/pages/picture-top-up";
import { AnimationTopUp } from "@/pages/animation-top-up";
import { FoxTopUp } from "@/pages/fox-top-up";
import "project-config/utils/title";
import { Whether } from "project-config/constants";
import DesktopCoupon from "@/pages/desktop-coupon";
// import { ErrorPage } from "@renderbus/widgets/components/error-page";
import { ErrorPage } from "@renderbus/widgets/components/error-page";
import { getUserId } from "@/utils/getUesrKey";
import { useSaveUserkey } from "project-config/hooks";

const basename = process.env.NODE_ENV === "development" ? "/" : "/center/user";

function App() {
  useSaveUserkey();
  useResponseInterceptor();
  useGlobalAuth();

  const { isSubAccount, isDomestic, isForeign, isPictureUser, userInfo } =
    useGlobalStore();

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <Layout />,
        errorElement: (
          <ErrorPage userId={userInfo?.userId || Number(getUserId())} />
        ),
        children: [
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "payment",
            element: <Payment />,
          },
          {
            path: "childCustomer",
            element: isSubAccount ? (
              <Navigate to="/" replace />
            ) : (
              <ChildCustomer />
            ),
          },
          {
            path: "project",
            element: <ProjectManage />,
          },
          {
            path: "coupon",
            element: <Coupon />,
          },
          {
            path: "desktop",
            element: !userInfo?.enableRemoteDesktop ? (
              <Navigate to="/" replace />
            ) : (
              <DesktopCoupon />
            ),
          },
          {
            path: "topUp",
            element: isSubAccount ? (
              <Navigate to="/" replace />
            ) : isPictureUser ? (
              <PictureTopUp />
            ) : isDomestic ? (
              <AnimationTopUp />
            ) : (
              <FoxTopUp />
            ),
          },
          {
            path: "invoice",
            element:
              isForeign || isSubAccount ? (
                <Navigate to="/" replace />
              ) : (
                <Invoice />
              ),
          },
          {
            path: "invoice/previous",
            element: <InvoiceHistory />,
          },
          {
            path: "exportList",
            element: <ExportList />,
          },
          {
            path: "operateRecord",
            element: <OperateRecord />,
          },
          {
            path: "consumption",
            element: <Consumption />,
          },
          {
            path: "consumption/previous",
            element:
              userInfo?.oldConsumptionBill === Whether.Yes ? (
                <PreviousConsumption />
              ) : (
                <Navigate to="/consumption" replace />
              ),
          },
          {
            path: "message/center",
            element: <Notification />,
          },
          {
            path: "authorization",
            element: isSubAccount ? (
              <Navigate to="/" replace />
            ) : (
              <AuthorizationManagement />
            ),
          },
          {
            path: "developer",
            element: <Developer />,
          },
          {
            path: "inviteRewards",
            element:
              !isDomestic || isSubAccount ? (
                <Navigate to="/" replace />
              ) : (
                <InviteRewards />
              ),
          },
          {
            path: "errorPage",
            loader: () => {
              throw new Error("模拟路由加载错误");
            },
          },
          {
            path: "",
            element: <Navigate to="/profile" replace />,
          },
        ],
      },
      {
        path: "clientTopUp",
        element: <ClientTopUp />,
      },
      {
        path: "*",
        element: <Navigate to="/profile" replace />,
      },
    ],
    { basename }
  );

  return <RouterProvider router={router} />;
}

export default App;
